import { Col } from 'antd'
import CardInfoTestDrive from 'components/ui/card/card-info-test-drive'
import CardJadwalTestDrive from 'components/ui/card/card-jadwal-test-drive'
import CardLokasiInspeksi from 'components/ui/card/card-lokasi-inspeksi'
import CardPilihBengkel from 'components/ui/card/card-pilih-bengkel'
import CustomButton from 'components/ui/custom-button'
import CardRincianBiaya from 'features/beli-mobil/components/card/card-rincian-biaya'
function FormJadwalkanInspeksi({
  state,
  homeState,
  schedule,
  workshops,
  times,
  price,
  taxPrice,
  totalPrice,
  provinces,
  cities,
  subdistricts,
  rangePrice,
  handleCancel,
  handleClick,
  isShowRoom,
  setIsShowRoom,
  handleChangeWorkshop,
  handleChangeSchedule,
  handleChangeHomeData,
  handleChangeLocation
}) {
  return (
    <Col span={22} md={20} className={`mx-auto grid grid-cols-1 gap-6`}>
      {/* className={`mx-auto grid grid-cols-1 gap-6 ${!isShowRoom ? 'md:grid-cols-[1fr_389px]' : ''}`}> */}
      {/* left content */}
      <div>
        <div className="grid grid-cols-1 gap-6">
          {/* lokasi */}
          <CardLokasiInspeksi
            isShowRoom={isShowRoom}
            setIsShowRoom={setIsShowRoom}
            workshops={workshops}
            state={state}
            homeState={homeState}
            provinces={provinces}
            cities={cities}
            subdistricts={subdistricts}
            rangePrice={rangePrice}
            handleChangeHomeData={handleChangeHomeData}
            handleChangeLocation={handleChangeLocation}
            handleChangeActiveWorkshop={handleChangeWorkshop}
          />
          {/* jadwal */}
          <CardJadwalTestDrive
            inspeksi
            workshops={workshops}
            times={times}
            schedule={schedule}
            handleChangeSchedule={handleChangeSchedule}
          />
          {/* pilih bengkel */}
          {!isShowRoom && (
            <CardPilihBengkel
              workshops={workshops}
              data={state}
              handleChangeActiveWorkshop={handleChangeWorkshop}
            />
          )}
          <div className="flex gap-3 justify-end items-center">
            <CustomButton type="secondary" label={'Sebelumnya'} onClick={handleCancel} />
            <CustomButton label={'Selanjutnya'} onClick={handleClick} />
          </div>
        </div>
      </div>
      {/* right content */}
      {/* {!isShowRoom ? (
        <div className="hidden md:block">
          <div className="grid grid-cols-1 gap-6">
            {isShowRoom ? (
              ''
            ) : (
              <CardRincianBiaya
                isShowRoom={isShowRoom}
                homeState={homeState}
                price={price}
                taxPrice={taxPrice}
                totalPrice={totalPrice}
              />
            )}
            <CardInfoTestDrive />
          </div>
        </div>
      ) : null} */}
    </Col>
  )
}

export default FormJadwalkanInspeksi
